import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { Observable } from 'rxjs';
import { PlainJaneCardData } from '../../../../../../../models/print-cards/plain-jane-card-data';
import { map } from 'rxjs/operators';
import { PrintCardColumnViewModel } from '../../../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/print-card-column-view-model';
import { SectionLayoutType } from '../../../../../../../models/enum/dto/section-layout-type.enum';
import { PrimaryCannabinoid } from '../../../../../../../models/enum/shared/cannabinoid';
import { SortUtils } from '../../../../../../../utils/sort-utils';
import { PropertyPoolSorter } from '../../shared/card-data-with-property-pooling';

@Injectable()
export class PlainJaneIndexCardStackContentViewModel extends PrintCardContentViewModel {
  private readonly pinnedSecondaryPropertyMap = new Map<string, number>([
    [PrimaryCannabinoid.THC, 0],
    [PrimaryCannabinoid.CBD, 1]
  ]);

  public readonly cardData$: Observable<PlainJaneCardData>;

  public readonly propertiesToDisplay$ = this.propertiesBasedOnPools$;

  public readonly gridPropertiesBasedOnPools$ = this.getGridPropertiesBasedOnPools$(this.spoofedGridColViewModels$);

  public showSize$ = this.cardData$.pipe(map(cardData => cardData?.showSize()));

  public showQuantity$ = this.cardData$.pipe(map(cardData => cardData?.showQuantity()));

  public gridHeader$ = this.showSize$.pipe(map(showSize => (showSize ? 'SIZE' : 'QTY')));

  public override getGridSize$(columnVM: PrintCardColumnViewModel): Observable<string> {
    return this.cardData$.pipe(
      map(cardData => {
        const variant = cardData?.getVariantFromGridColumn(columnVM);
        const isEdible = !cardData?.showSize();
        const locationId = cardData?.locationConfig?.locationId;
        const gridName = variant?.getGridNames(SectionLayoutType.Grid, locationId)?.firstOrNull()?.replace(/\s/g, '');
        return isEdible ? gridName?.replace('pk', 'pc') : gridName;
      })
    );
  }

  protected override emptyPropertyValueForPropertiesBasedOnPools(): string {
    return '-';
  }

  protected override finalSortLambdaForCompoundProperties(): PropertyPoolSorter {
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title);
  }

  protected override getSecondaryPoolOfCompoundPropertiesSortLambda(): PropertyPoolSorter {
    const defaultSort = super.getSecondaryPoolOfCompoundPropertiesSortLambda();
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title) || defaultSort(a, b);
  }
}
